import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary" }, "Reset", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", null, [
      _createVNode(_component_TextInput, {
        type: "text",
        name: "mixed",
        placeholder: "Search by NBF Participant ID, First or Last Name",
        max: 100,
        modelValue: $setup.password,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.password) = $event))
      }, null, 8, ["modelValue"]),
      _hoisted_1
    ])
  ]))
}